module.exports = __webpack_public_path__ + "img/fumax_logo.a73b1730.png";